import { defaultLocale } from './locales'

// The default-locale homepage lives at the bare host (`/`), not `/${defaultLocale}`.
// See src/proxy.ts: `/` serves the default-locale homepage and `/${defaultLocale}`
// 301-redirects to `/`. Shared by every navigation helper (Link, getPathname,
// redirect, useRouter) so they canonicalize the default-locale homepage identically.
// Lives in its own leaf module (no React, no client/server imports) so the
// server-safe and `'use client'` navigation modules can both depend on it without a
// cycle. `href` is `unknown` to cover the string + UrlObject shapes.
export const isDefaultLocaleHomepage = (href: unknown, locale: string): boolean =>
    locale === defaultLocale &&
    (href === '/' ||
        (typeof href === 'object' &&
            href !== null &&
            (href as { pathname?: unknown }).pathname === '/'))
